import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04b340da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-view" }
const _hoisted_2 = { class: "btn-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HakoBsIcon = _resolveComponent("HakoBsIcon")!
  const _component_HakoButton = _resolveComponent("HakoButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showBurger)
        ? (_openBlock(), _createBlock(_component_HakoButton, {
            key: 0,
            sm: "",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('toggle-panel')), ["prevent"])),
            class: "hamburger-sidepanel"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_HakoBsIcon, { icon: "list" })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}